import { gql, TypedDocumentNode } from '@apollo/client';

import { JobBoardDto, QueryGetJobPositionScoreArgs } from '@pflegia/data-access';

import { JOB_POSITION_FOR_CANDIDATE_FRAGMENT } from '../fragments/job-position-for-candidate';

export const GET_JOB_POSITIONS_LIST: TypedDocumentNode<{ data: JobBoardDto }, QueryGetJobPositionScoreArgs> = gql`
  query getCandidatePotentialJobs(
    $sortField: String!
    $sortOrder: String
    $page: Int!
    $perPage: Int!
    $filter: PotentialMatchFilterInput
    $isMinifiedJobBoard: Boolean
  ) {
    data: getJobPositionScore(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
      isMinifiedJobBoard: $isMinifiedJobBoard
    ) {
      jobPositions {
        ...JobPositionForCandidate
        recommended
      }
      total
      expandedRadiusKm
    }
  }
  ${JOB_POSITION_FOR_CANDIDATE_FRAGMENT}
`;
